import { useState, useEffect, useRef } from 'react'

const TOAST_DURATION = 2500

const baseStyle = {
  position: 'fixed',
  top: '70px',
  left: '50%',
  transform: 'translateX(-50%)',
  padding: '12px 24px',
  borderRadius: '8px',
  zIndex: 2000,
  fontWeight: 'bold',
  boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
}

const toastStyles = {
  success: {
    ...baseStyle,
    background: '#4CAF50',
    color: '#fff',
  },
  error: {
    ...baseStyle,
    background: '#f44336',
    color: '#fff',
  },
}

// Hook-based toast for functional components
export function useToast() {
  const [toast, setToast] = useState(null)
  const timeoutRef = useRef(null)

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  const showToast = (message, type = 'success') => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    setToast({ message, type })
    timeoutRef.current = setTimeout(() => setToast(null), TOAST_DURATION)
  }

  return { toast, showToast }
}

// Toast component - display only
export default function Toast({ toast }) {
  if (!toast) return null

  return (
    <div style={toastStyles[toast.type] || toastStyles.success}>
      {toast.message}
    </div>
  )
}